import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function addNewRound(league_pk, round_date) {
  const token = Cookies.getToken();

  try {
    const res = await axios({
      method: 'POST',
      url:
        process.env.REACT_APP_API_URL +
        `/api/league/leagues/${league_pk}/rounds/`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        league_pk: league_pk,
        round_date: round_date,
      },
    });
    return res;
  } catch (error) {
    return { error: error };
  }
}

